import { render, staticRenderFns } from "./default.vue?vue&type=template&id=0906743c&lang=pug&"
import script from "./default.vue?vue&type=script&lang=coffee&"
export * from "./default.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notifications: require('/opt/buildhome/repo/components/notifications/notifications.vue').default})
